<template>
  <div
    data-tst="horizontal_chart"
    class="horizontal-chart horchart"
    :class="[{ horchart_skeleton: skeleton }, { 'horchart_legend-read-only': readOnly }]"
  >
    <!-- <slot name="title">
      <div class="d-flex text_tab_small">
        {{ $t(`common.actions`) }}
        <slot name="title_after"></slot>
      </div>
    </slot> -->
    <div
      v-if="hasLegend"
      ref="hscrl_inner"
      class="horchart_legend no-scroll-track"
      @wheel.stop="e => hscrl_wheelScroll(e)"
      @mousedown.stop="e => hscrl_dragScrollMousedown(e)"
    >
      <!-- v-for="(action, aIdx) in [
          ...legendActions,
          ...legendActions,
        ]" -->
      <div
        v-for="(action, aIdx) in legendActions"
        :key="`${action.code || action.id}_${aIdx}`"
        class="horchart_legend_item gw_btn_hover_back"
        :class="[
          `clr-${action.css_class}`,
          {
            gw_btn_hover_back_active: !activeActions
              ? false
              : activeActions.some(
                  aa =>
                    aa.code === action.code ||
                    (action.actions || []).some(aaa => aa.code === aaa.code),
                ),
          },
        ]"
        :style="`${useHex ? `color:${action.hex};` : ''}
                 --value-percent:${action[freKey] * 100}%`"
        @click="handleActionClick(action)"
      >
        <div>
          {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
          <span class="horchart_legend_item_name">
            <span v-html="getBetHtml({ showBetsIn, a: action })"></span>
          </span>
        </div>
        <div class="horchart_legend_item_value position-relative">
          <GwMenu
            v-if="hasBreakdown && action.total_combos > 0.001"
            ref="gwmenu"
            :isMovable="true"
            :flOptions="{
              placement: 'left-start',
              offset: -14,
            }"
            class="my-auto ml-auto mr-1"
            style="position: absolute; z-index: 4; right: 3.5rem"
            trigger="hover"
            @click.stop
          >
            <template #opener>
              <div
                class="sab_btn_breakdown f-center"
                @click.stop
              >
                <i class="mdi mdi-chart-box-outline sab_btn_breakdown_icon"></i>
              </div>
            </template>
            <div
              class="gw_menu"
              style="--width: auto; padding: 0.75rem 0 1rem 0"
            >
              <StudyComboBreakdown
                :action="action"
                :catDraws="catDraws"
                :catHands="catHands"
              />
            </div>
          </GwMenu>
          {{ numFixedUnit((action[freKey] || 0) * 100, 'strategy') }}%
        </div>
      </div>
    </div>
    <div class="horchart_chart">
      <div
        v-for="(action, aIdx) in solution"
        :key="`${action.code}_${aIdx}`"
        class="horchart_chart_item"
        :class="`${action.css_class}`"
        :style="`width: ${action[freKey] * 100}%; ${useHex ? `background:${action.hex}` : ''}`"
      />
      <slot />
    </div>
    <div
      v-if="canExpand"
      :class="!expanded ? 'mdi-chevron-double-down' : 'mdi-chevron-double-up'"
      class="mdi icon_btn horchart_expand_btn csst"
      data-tst="horizontal_chart_expand"
      @click="toggleExpand"
    >
      <!-- class="mdi gw_btn horchart_expand_btn csst" -->
      <div
        class="csst_content"
        style="top: -1.5em"
      >
        {{ expanded ? $t('tooltips.collapse') : $t('tooltips.expand') }}
      </div>
    </div>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import { getImportantActions, getGroupedActions } from '@/helpers/grouping'
import StudyComboBreakdown from '@/components/Study/StudyComboBreakdown'

import format_mix from '@/mixins/format_mix'
import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'

export default {
  name: 'HorizontalChart',
  components: {
    StudyComboBreakdown,
    GwMenu,
  },
  mixins: [horizontalScroll_mix, format_mix],
  props: {
    skeleton: { type: Boolean, default: true },
    hasLegend: { type: Boolean, default: true },
    limitLegendTo: { default: 0 },
    legendRaiseFirst: { type: Boolean, default: true },
    hasExpand: { type: Boolean, default: true },
    chartRaiseFirst: { type: Boolean, default: true },
    grouping: { default: () => 'swv_grouping_none' },
    useHex: { type: Boolean, default: true },
    showBetsIn: String,
    solution: Array,
    activeActions: Array,
    freKey: { default: () => 'total_frequency' },
    readOnly: Boolean,
    hasBreakdown: Boolean,
    catDraws: Array,
    catHands: Array,
  }, 
 emits: ['action:click'],
  data() {
    return {
      expanded: false,
    }
  },
  mounted() {
    if (this.hasExpand) {
      this.expanded = localStorage.getItem('horchart_expanded') === 'true'
    }
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded
      localStorage.setItem('horchart_expanded', this.expanded ? 'true' : 'false')
    },
    handleActionClick(action) {
      if (this.readOnly) return
      this.$emit('action:click', action)
    },
  },
  computed: {
    l_solution() {
      const res = getGroupedActions({
        actions: this.solution,
        grouping: this.grouping,
        groupValues: [this.freKey],
        raisesFirst: this.chartRaiseFirst,
      })
      // console.log(res)
      return res
    },
    legendActions() {
      let res = this.l_solution
      // console.log(this.useHex)
      if (!this.useHex) {
        // console.log(res)
        return res
      }
      if (this.limitLegendTo && !this.expanded) {
        res = getImportantActions({
          actions: res,
          max: this.limitLegendTo,
          sortKey: this.freKey,
          raisesFirst: this.legendRaiseFirst,
        })
      }
      res = getImportantActions({
        actions: res,
        max: 99,
        sortKey: this.freKey,
        raisesFirst: this.legendRaiseFirst,
      })
      return res
    },

    canExpand() {
      return this.hasExpand ? this.limitLegendTo < this.l_solution.length : false
    },
  },
}
</script>

<style lang="scss" scoped>
.horchart_legend-no-events {
  .horchart_legend {
    pointer-events: none;
  }
}

.horchart {
  --legend-gap: 0px;
  --legend-item-padding: 0;
  --legend-item-margin: 0;
  --legend-item-weight: 700;
  --legend-item-radius: 8px;
  --legend-item-transform: none;
  --clr-value: currentColor;

  --chart-margin: 0;
  --legend-item-line-height: 1.2;
  --legend-item-line-height: 1.3;
  --legend-margin: 0 0 0.25em 0;

  --legend-item-size: 1em;
  // --chart-height: 1em;
  --chart-height: var(--height-chart-small);

  --clr-chart-back: var(--clr-black-3);

  width: 100%;
  min-width: 0;
  position: relative;

  &_skeleton {
    --clr-back: var(--clr-black-3);
    .horchart_legend {
      display: none;
    }
    .horchart_chart {
      &:before {
        content: '';
        height: 100%;
        width: 100%;
        z-index: 1;
        background: var(--clr-back);
        position: absolute;
      }
    }
    .trarangeshand_chart_column {
      display: none;
    }
  }
  &_legend-read-only {
    .horchart_legend {
      &_item {
        pointer-events: none;
      }
    }
  }
  &_legend-inline {
    .horchart_legend {
      display: flex;
      grid-gap: 1em;
      overflow-x: auto;
      overflow-y: hidden;
      .horchart_legend_item {
        cursor: pointer;
        &:first-child {
          margin-left: auto;
        }
        &:last-child {
          margin-right: auto;
          &:after {
            display: none;
          }
        }
      }
    }
  }
  &_legend {
    display: grid;
    width: 100%;
    grid-gap: var(--legend-gap);
    position: relative;
    grid-template-columns: var(--grid-template-columns);
    margin: var(--legend-margin);
    &_item {
      cursor: pointer;
      border-radius: var(--legend-item-radius);
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      line-height: var(--legend-item-line-height);
      margin: var(--legend-item-margin);
      padding: var(--legend-item-padding);
      position: relative;
      font-size: var(--legend-item-size);
      font-weight: var(--legend-item-weight);
      text-transform: var(--legend-item-transform);
      border-radius: 4px;

      height: 1.5em;

      --btn-back-z-index: 1;
      --btn-back-inset: 0 auto auto -0.25rem;
      --btn-back-width: calc(100% + 0.5rem);
      &_value {
        margin: 0 0 0 auto;
        padding: 0 0 0 0.5em;
        color: var(--clr-value);
      }
    }
  }
  &_expand {
    &_btn {
      opacity: 0;
      position: absolute;
      bottom: 1em;
      left: 50%;
      transform: translate(-50%, 0);
      padding: 0.25em;
      font-size: 1.25em;
      z-index: 4;
    }
  }
  &:hover {
    .horchart_expand_btn {
      opacity: 1;
    }
  }
  &_chart {
    display: flex;
    margin: var(--chart-margin);
    background: var(--clr-chart-back);
    flex: 1;
    height: var(--chart-height);
    overflow: hidden;
    border-radius: 4px;
    position: relative;
    &_item {
      min-height: 100%;
      transition: width 0.2s;
      will-change: width;
    }
  }
}
</style>
